export const getBackendBaseUrl = () => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    // Check if localhost, 127.0.0.1, or local LAN IP (e.g. 192.168.x.x, 10.x.x.x, 172.16.x.x)
    if (
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      /^192\.168\.\d+\.\d+$/.test(hostname) ||
      /^10\.\d+\.\d+\.\d+$/.test(hostname) ||
      /^172\.(1[6-9]|2\d|3[01])\.\d+\.\d+$/.test(hostname)
    ) {
      return `http://${hostname}:8080`;
    }
  }
  return process.env.REACT_APP_API_URL || "https://rc3t9mm4e4.execute-api.ap-south-1.amazonaws.com/dev";
};

export const getWebSocketUrl = () => {
  if (process.env.REACT_APP_WS_URL) {
    return process.env.REACT_APP_WS_URL;
  }
  // AWS API Gateway WebSocket Stage URL
  return "wss://cepx4419b0.execute-api.ap-south-1.amazonaws.com/Dev/";
};
